import { find, get } from 'lodash/fp';
import request from 'utils/request_ajax';
import invariant from 'utils/invariant';
import { updatePath } from './actionCreators';
import { TYPES, routes } from '../../constants/config';
import { PATH_BUILDER } from '../../constants/actionTypes';

export function createLibraryContent(group) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { id: pathId } = getState().pathBuilder;
      const libraryContent = {
        assignableId: pathId,
        assignableType: TYPES.PATH,
        groupId: group.id,
      };
      request
        .postJSON(routes.LIBRARY_CONTENTS, { libraryContent })
        .then(data => {
          dispatch({
            type: PATH_BUILDER.LIBRARY_CONTENT.CREATE,
            libraryContent: data,
          });
        });
    });
}

export function removeLibraryContent(libraryContent) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      request.delete(routes.LIBRARY_CONTENT(libraryContent.id)).then(() => {
        dispatch({
          type: PATH_BUILDER.LIBRARY_CONTENT.REMOVE,
          libraryContent,
        });
      });
    });
}

export function setLibraryVisibilityForEveryone(visibility) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { meta, pathBuilder } = getState();
      const { everyoneGroup } = get('currentCompany')(meta);

      invariant(
        everyoneGroup.id,
        "Failed to add to learning library. Group 'Everyone' cannot be found",
      );

      if (visibility === true) {
        dispatch(createLibraryContent(everyoneGroup));
      } else {
        const everyoneGroupLibraryContent = find(
          content => content.group.id === everyoneGroup.id,
        )(pathBuilder.libraryContents);
        dispatch(removeLibraryContent(everyoneGroupLibraryContent));
      }
    });
}

export function reloadLibraryContents() {
  return (dispatch, getState) => {
    const { id: pathId } = getState().pathBuilder;
    request
      .get(routes.PATH_VIEW(pathId))
      .then(response => response.libraryContents)
      .then(libraryContents => {
        dispatch(updatePath({ libraryContents }));
      });
  };
}
